import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-herbal',
  templateUrl: './herbal.component.html',
  styleUrls: ['./herbal.component.scss']
})
export class HerbalComponent implements OnInit {
  imgUrl=[
    '/assets/img/playground/1.jpeg'
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
